import React from 'react';
import {Client} from '@wandb/cg/browser';

export interface ClientState {
  client?: Client;
}

const ClientContext = React.createContext<ClientState>({
  client: undefined,
});

export default ClientContext;
